import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silently swallow PostHog session-replay's PerformanceServerTiming clone
// errors. These come from the platform's analytics injector (posthog-recorder.js),
// not from our app, but CRA's dev overlay catches them and blocks the UI.
// They are harmless (PostHog falls back to a partial recording) — we just
// don't want the red banner shoved over the user's screen on Safari.
const POSTHOG_NOISE = /posthog-recorder\.js|PerformanceServerTiming/i;
const isPosthogNoise = (msg, source) =>
  (typeof msg === "string" && POSTHOG_NOISE.test(msg)) ||
  (typeof source === "string" && POSTHOG_NOISE.test(source));

window.addEventListener("error", (ev) => {
  if (isPosthogNoise(ev.message, ev.filename) || isPosthogNoise(ev.error?.stack, "")) {
    ev.stopImmediatePropagation();
    ev.preventDefault();
  }
}, true);

window.addEventListener("unhandledrejection", (ev) => {
  const reason = ev.reason;
  const text = (reason && (reason.stack || reason.message)) || String(reason || "");
  if (POSTHOG_NOISE.test(text)) {
    ev.stopImmediatePropagation();
    ev.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
